// API URLs and other static constants
export const API_URL = "https://platform.instadev.ai/";
export const API_URL_SOCKET = "https://platform.instadev.ai/";

// Other constants can be added here
export const APP_NAME = "InstaDev";
export const APP_VERSION = "1.0.0";